import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface ToggleViewContainerProps {
  children: React.ReactNode;
}

const ContainerComponent: React.FC<ToggleViewContainerProps> = ({
  children,
}) => {
  return <div className="peptalk-toggle-view">{children}</div>;
};

export const Container: React.FC<ToggleViewContainerProps> = (
  props: ToggleViewContainerProps
) => {
  const Component = useCustomComponent({
    componentName: 'ToggleViewContainer',
    Component: ContainerComponent,
  });

  return <Component {...props} />;
};
